export const TENANT_PROJECT_DEPOSIT_SYNC_ACTION = Object.freeze({
  allowContractorRefund: 'allowContractorRefund',
  depositNotifyPM: 'depositNotifyPM',
  depositNotifyAccounting: 'depositNotifyAccounting',
  managementFeeNotifyPM: 'managementFeeNotifyPM',
  managementFeeNotifyAccounting: 'managementFeeNotifyAccounting',
  refundNotifyPM: 'refundNotifyPM',
  refundNotifyAccounting: 'refundNotifyAccounting',
  resumeRefundRequest: 'resumeRefundRequest',
})

const TENANT_PROJECT_DEPOSIT_SYNC_KEY = 'tenant-project-deposit-action-sync'

export function emitTenantProjectDepositSync (tenantProjectId, action) {
  if (typeof window === 'undefined') {
    return
  }

  localStorage.setItem(TENANT_PROJECT_DEPOSIT_SYNC_KEY, JSON.stringify({
    action,
    tenantProjectId,
    timestamp: Date.now(),
  }))
}

export function parseTenantProjectDepositSyncEvent (event, tenantProjectId, actions = []) {
  if (!event || event.key !== TENANT_PROJECT_DEPOSIT_SYNC_KEY || !event.newValue) {
    return null
  }

  try {
    const syncData = JSON.parse(event.newValue)

    if (String(syncData.tenantProjectId) !== String(tenantProjectId)) {
      return null
    }

    if (actions.length && !actions.includes(syncData.action)) {
      return null
    }

    return syncData
  } catch (err) {
    return null
  }
}
